module.exports = __webpack_public_path__ + "static/29-a736fb14d4eee611f09d0192121f3c16.jpg";